/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { SelfCheckinRequest } from '../../models/self-checkin-request';
import { SelfCheckinTokenResponse } from '../../models/self-checkin-token-response';

export interface PostGenerateSelfCheckinToken$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
      body: SelfCheckinRequest
}

export function postGenerateSelfCheckinToken(http: HttpClient, rootUrl: string, params: PostGenerateSelfCheckinToken$Params, context?: HttpContext): Observable<StrictHttpResponse<SelfCheckinTokenResponse>> {
  const rb = new RequestBuilder(rootUrl, postGenerateSelfCheckinToken.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SelfCheckinTokenResponse>;
    })
  );
}

postGenerateSelfCheckinToken.PATH = '/administration/organization-sites/{organizationSiteKey}/self-checkin-tokens';
